import styled from "styled-components";

export const ComponentContainer = styled.div`
  @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 5px;
  } 
`;

export const Heading = styled.h2`
    font-family: Overpass;
    font-style: normal;
    font-size: 28px;
    font-weight: 500;
    line-height: 0.8;
    color: #151515;
    margin-top: 0px;
    margin-bottom: 20px;

    @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
      font-size: 36px;
    }
`;

export const SubHeading = styled.h3`
  font-family: Overpass;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  color: #151515;
  margin: 20px 0px;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.lg}){
    font-size: 28px;
  }
`;